import { Route, Routes } from "react-router-dom";
import "./App.css";
// import Dashboard from "./components/dashboard/Dashboard";
import Sidebar from "./components/common/Sidebar";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
function App() {
  return (
    <>
      <Sidebar />
      {/* <Routes><Route path="/" element={<Dashboard />} /></Routes> */}
    </>
  );
}

export default App;
